const pickProperties = require('../utils/pickProperties');
const cleanObject = require('../utils/cleanObject');


module.exports.getDestinationItem = function(
  sourceItem, 
  destinationKey, 
  { reason, percentage, quantity },
  keysToCopy = [
    'quantity', 
    'producerproduct_id', 
    'kelbongoo_price', 
    'consumer_price', 
    'tva'
  ]
){

  let additionalParams = { quantity };

  if(destinationKey === 'reduced' || destinationKey === 'added-reduced'){
    Object.assign(additionalParams, { reason, percentage });
  }
  if(destinationKey === 'removed'){
    Object.assign(additionalParams, { reason });
  }

  return Object.assign(
    pickProperties.run(sourceItem, keysToCopy), 
    cleanObject.run(additionalParams)
  );
};